export default "__VITE_ASSET__DwbNksS3__"